const UserActionTypes = {
	SET_USER: 'SET_USER',
	REMOVE_USER: 'REMVOE_USER'
};

export default UserActionTypes;
